// ---------------------------------------------------------------------------
// Single place to rebrand the site. Anything user-visible or SEO-facing should
// read from here rather than hardcoding the name.
//
// TO RENAME THE SITE, change SITE_NAME / SITE_URL below, then update the four
// files that cannot import this ES module:
//   - scripts/seo-lib.js   (SITE constant — runs in Node at build time)
//   - public/robots.txt    (Sitemap: line)
//   - public/manifest.json (name / short_name / description)
//   - public/index.html    (fallback <title> and the <noscript> block)
// ---------------------------------------------------------------------------

export const SITE_NAME = 'BlogFanda';
export const SITE_URL = 'https://www.blogfanda.com';
export const SITE_TAGLINE = 'News, Stories & Everything In Between';
export const SITE_DESCRIPTION =
  'News, stories and guides on everything worth knowing — world events, business, technology, sport, entertainment and everyday life, all in one place.';

// Used as the fallback author on posts and in the Article JSON-LD.
export const SITE_AUTHOR = 'BlogFanda Team';

// Shown in the footer and used for the Organization JSON-LD `sameAs` list.
// Empty strings are skipped, so it is safe to fill these in later.
export const SOCIAL_LINKS = [
  { label: 'X', href: '' },
  { label: 'GitHub', href: '' },
  { label: 'LinkedIn', href: '' },
];

// twitter:site handle for social cards (include the @). Optional.
export const TWITTER_HANDLE = '';

export const CONTACT_EMAIL = 'hello@blogfanda.com';

/*
 * Fallback share image, used for og:image / twitter:image on any page without its
 * own cover.
 *
 * TODO: replace with a real raster image, 1200×630, and keep it at a stable path.
 * X, Facebook and LinkedIn do NOT render SVG in a social card, so the placeholder
 * below shows no preview image on those platforms — it only keeps the tag from
 * pointing at a 404.
 */
export const SOCIAL_IMAGE = '/default-blog.svg';

// Shown as "Last updated" on the privacy and terms pages. A fixed date on
// purpose: rendering new Date() there would claim the documents were revised
// today on every build, and would make the prerendered HTML non-deterministic.
// Bump this by hand whenever the wording actually changes.
export const LEGAL_UPDATED = '2026-08-01';
